import { connect } from 'react-redux';
import NavBarNew from '../../../components/PageStructure/NavBar/NavBarNew';
import { getSettings } from '../../../actions/entities';
import _ from '../../../utils/lodash';

const mapStateToProps = ({ router: { location }, entities: { settings }, global: { auth } }) => {
  const { pathname } = location;
  const enableSendingRequestLogsToRioSetting = auth.settings
    ? _.find(auth.settings, 'EnableSendingRequestLogsToRio')
    : {};
  return {
    currentPathname: pathname,
    appSettings: settings.appSettings,
    externalProviderType: auth.externalProviderType,
    featureAccessList: auth.featureAccessList,
    tenatCode: auth.tenantCode,
    enableSendingRequestLogsToRio: _.values(enableSendingRequestLogsToRioSetting)[0],
  };
};

const mapDispatchToProps = dispatch => ({
  getAppSettings: kv => {
    dispatch(getSettings(kv));
  },
});

const NavBarContainerNew = connect(
  mapStateToProps,
  mapDispatchToProps,
)(NavBarNew);

export default NavBarContainerNew;
